"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialGmcValues = exports.GOOGLE_MERCHANT_CENTER = void 0;
exports.GOOGLE_MERCHANT_CENTER = "GOOGLE_MERCHANT_CENTER";
exports.initialGmcValues = {
    type: exports.GOOGLE_MERCHANT_CENTER,
    data: {
        merchantId: "",
        storeName: "",
    },
};
